const availableLanguages = [
  { iso2: 'ee', iso3: 'est' },
  { iso2: 'en', iso3: 'eng' },
  { iso2: 'ru', iso3: 'rus' },
  { iso2: 'fi', iso3: 'fin' }
];

export default availableLanguages;
